import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { User, UserFormValues } from "../models/user";
import { router } from "../router/Routes";
import { store } from "./store";
import {  AuthErrorCodes, getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { app } from "../../firestore-config";
import { toast } from 'react-toastify';

export default class UserStore {
    user: User | null = null;

    constructor() {
        makeAutoObservable(this)
    }

    get isLoggedIn() {
        return !!this.user;
    }

    login = async (creds: UserFormValues) => {
        try {
            const auth = getAuth(app);
            //const user = await agent.Account.login(creds);
            signInWithEmailAndPassword(auth, creds.email, creds.password)
      .then((userCredential) => {
        // Signed in
        console.log(userCredential.user);
        store.commonStore.setToken(userCredential.user.refreshToken);
        const newuser:User = 
         {                        
            displayName: userCredential.user.displayName!,
            username: userCredential.user.email!,
            token:userCredential.user.refreshToken
        };
        runInAction(() => this.user = newuser);
            router.navigate('/activities');
            store.modalStore.closeModal();
      })
      .catch((err) => {
        if (
        err.code === AuthErrorCodes.INVALID_PASSWORD ||
        err.code === AuthErrorCodes.USER_DELETED
      ) {
        toast.error('The email address or password is incorrect');        
      } else {
        console.log(err.code);
        alert(err.code);
      }
      });   
        } catch (error) {
            throw error;
        }
    }

    register = async (creds: UserFormValues) => {
        try {
            const user = await agent.Account.register(creds);
            store.commonStore.setToken(user.token);
            runInAction(() => this.user = user);
            router.navigate('/activities');
            store.modalStore.closeModal();
        } catch (error) {
            throw error;
        }
    }
    // enquiry = async (enquiry: EnquiryFormValues) => {
    //     try {
    //         const user = await agent.Account.register(enquiry);
    //         store.commonStore.setToken(user.token);
    //         runInAction(() => this.user = user);
    //         router.navigate('/activities');
    //         store.modalStore.closeModal();
    //     } catch (error) {
    //         throw error;
    //     }
    // }


    logout = () => {
        store.commonStore.setToken(null);
        this.user = null;
        router.navigate('/');
    }

    getUser = async () => {
        try {
            const user = await agent.Account.current();
            runInAction(() => this.user = user);
        } catch (error) {
            console.log(error);
        }
    }

    setImage = (image: string) => {
        if (this.user) this.user.image = image;
    }

    setUserPhoto = (url: string) => {
        if (this.user) this.user.image = url;
    }

    setDisplayName = (name: string) => {
        if (this.user) this.user.displayName = name;
    }
}